<div class="brand-area {{pb}} {{pt}}">
    <div class="container">
        <div class="row">
            <div class="brand-wrap owl-carousel owl-theme">
                <div class="single-brand">
                    <img src="assets/img/brand-logo/brand-logo-one.png" alt="Image">
                </div>

                <div class="single-brand">
                    <img src="assets/img/brand-logo/brand-logo-two.png" alt="Image">
                </div>

                <div class="single-brand">
                    <img src="assets/img/brand-logo/brand-logo-three.png" alt="Image">
                </div>

                <div class="single-brand">
                    <img src="assets/img/brand-logo/brand-logo-four.png" alt="Image">
                </div>

                <div class="single-brand">
                    <img src="assets/img/brand-logo/brand-logo-five.png" alt="Image">
                </div>
            </div>
        </div>
    </div>
</div>